import { memo } from "react";
import { Outlet } from "react-router-dom";

import * as css from "./app-shell.module.css";
import { ImpersonationBanner } from "./impersonation-banner";
import { PageErrorBoundary } from "./page-error-boundary";
import { Sidebar } from "./sidebar";

/** Two-pane shell for authenticated routes. `.referrals-app-shell` scopes dashboard tokens. */
export const AppShell = memo(function AppShell() {
  return (
    <div className={`referrals-app-shell ${css.shell}`}>
      <Sidebar />
      <main className={css.main}>
        <ImpersonationBanner />
        <PageErrorBoundary>
          <Outlet />
        </PageErrorBoundary>
      </main>
    </div>
  );
});
